export const ERROR_CODE_PROD_SERV_NOT_FOUND_1 = 'PS_NF_1';
export const ERROR_MSG_PROD_SERV_NOT_FOUND_1 = 'Organisatie bij pas is nog niet bekend, koppeling is morgen beschikbaar';
export const ERROR_TITLE_PROD_SERV_NOT_FOUND_DEFAULT = 'Kan productservices niet vinden';
